import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomInvoiceHistoryComponent} from './custom-invoice-history.component';
import {AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule} from '@spartacus/core';
import {CustomIconsModule} from '../../../../../../custom/icons/custom-icons.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DatePickerModule, PaginationModule, SpinnerModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';
import {NgSelectModule} from '@ng-select/ng-select';
import {CustomDatePickerModule} from "../../../../../../custom/forms/date-picker/custom-date-picker.module";


@NgModule({
    imports: [
        CommonModule,
        ConfigModule.withConfig({
            cmsComponents: {
                AccountInvoicesHistoryComponent: {
                    component: CustomInvoiceHistoryComponent,
                    guards: [AuthGuard],
                },
            },
        } as CmsConfig),
        CustomIconsModule,
        I18nModule,
        ReactiveFormsModule,
        FormsModule,
        CustomDatePickerModule,
        PaginationModule,
        UrlModule,
        RouterModule,
        NgSelectModule,
        SpinnerModule
    ],
    declarations: [CustomInvoiceHistoryComponent],
    exports: [CustomInvoiceHistoryComponent]
})
export class CustomInvoiceHistoryModule {
}
